import { theme } from '@/styles/theme';

export const styles = {
  list: {
    width: '100%',
    overflowY: 'auto',
    marginTop: '-15px',
  },
  item: {
    borderRadius: 2,
    border: '1px solid #FAFFFD',
    marginBottom: 2,
    cursor: 'pointer',
    minHeight: 80,
  },
  itemFocused: {
    '&.Mui-selected': {
      backgroundColor: theme.palette.focus.light,
      borderColor: theme.palette.focus.main,
    },
    '&:hover': {
      backgroundColor: theme.palette.focus.light,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.focus.light,
    },
  },
  itemNotFocused: {
    borderColor: theme.palette.opaqueGray.main,
  },
  titleCard: {
    fontSize: '14px',
  },
  subtitleCard: {
    fontSize: '14px',
  },
  photo: {
    fontSize: 16,
    backgroundColor: 'white',
    color: theme.palette.focus.main,
    boxShadow: 3,
  },
};
